(function (module) {
    "use strict";

    module.service('mathFunctionService', ['synchronousEventsBus', 'regressionCalculator', 'dtpChartService', '$q',
        function(
            this: $TSFixMe,
            synchronousEventsBus: $TSFixMe,
            regressionCalculator: $TSFixMe,
            dtpChartService: $TSFixMe,
            $q: ng.IQService
        ) {
            var service = this;

            service.registerEvents = function () {
                synchronousEventsBus.$on('dataAfterSmoothingChanged', function (e: $TSFixMe, args: $TSFixMe) {
                    return service.calculateRegression(args.forecast, args.parameters, args.forecast.regression);
                });
            }

            service.calculateRegression = function (forecast: $TSFixMe, parameters: $TSFixMe, type: $TSFixMe) {


                if (angular.isUndefinedOrNull(forecast.dataAfterSmoothing)) {
                    return;
                }


                if (angular.isUndefinedOrNull(type))
                    return $q.when();

                return calculate(forecast, parameters, type)
                    .then(
                        (data: $TSFixMe) => {
                            if (!Array.isArray(data.regression))
                                return;

                            forecast.regressionWholePeriod = data.regression;
                            forecast.regressionRFactor = data.r;
                            forecast.regressionMapeFactor = data.mape;
                            var preToForecastDuration = dtpChartService.getPeriodLenghtInMonths(parameters.historicalDataStart, parameters.forecastStartDate);
                            forecast.statisticalForecast = data.regression.slice().splice(preToForecastDuration - 1).map((value: $TSFixMe) => value < 0 ? 0 : value);
                            return synchronousEventsBus.$broadcast('regressionCalculated', { forecast: forecast, parameters: parameters });
                        });
            }

            function calculate(forecast: $TSFixMe, parameters: $TSFixMe, type: $TSFixMe) {
                switch (type) {
                    case 'periodical_linear':
                    case 'periodical_logarithmic':
                        return calculateRegression(forecast, parameters, type);
                    case 'machine_learning':
                        return perdictML(forecast, parameters);
                    default:
                        return $q.when();
                }
            }

            function calculateRegression(forecast: $TSFixMe, parameters: $TSFixMe, type: $TSFixMe) {
                var duration = dtpChartService.getPeriodLenghtInMonths(parameters.historicalDataStart, parameters.forecastEndDate);
                var x = [];
                var y = [];
                var index = 0;
                for (; index < forecast.dataAfterSmoothing.length; index++) {
                    if (!isNaN(forecast.dataAfterSmoothing[index]))
                        break;
                }
                var startIndex = index;
                for (; index < forecast.dataAfterSmoothing.length; index++) {
                    var value = forecast.dataAfterSmoothing[index];

                    if (!angular.isUndefinedOrNull(value) && !isNaN(value)) {
                        x.push(index + 1);
                        y.push(parseFloat(value));
                    }
                }
                
                var x_pred = _.range(startIndex + 1, duration + 1);


                if (angular.isUndefinedOrNull(type))
                    return $q.when();

                
                var firstMonthWithData = moment(parameters.historicalDataStart).add(x[0], 'months').month() + 1;

                return regressionCalculator.postRegression(type, x, y, x_pred, firstMonthWithData)
                    .then((result: $TSFixMe) => {
                        return {
                            
                            regression: _.times(startIndex, _.constant(null)).concat(result.regression),
                            r: parseError(result.r),
                            mape: parseError(result.mape)
                        };
                    });

            }

            function perdictML(forecast: $TSFixMe, parameters: $TSFixMe) {

                
                const ml = _.find(angular._get(forecast, 'machineLearningData', []), (element: $TSFixMe) => element.monthNumberForAverage == forecast.period);
                if (ml && ml.calculationIsReady) {
                    return regressionCalculator.postML(ml.modelId).then((mlResult: $TSFixMe) => {
                        return {
                            regression: mlResult.result,
                            mape: parseError(mlResult.error)
                        };
                    });
                } else {
                    return $q.when({ regression: null, r: null });
                }
            }

            function parseError(v: $TSFixMe) {
                const value = parseFloat(v);
                return isNaN(value) ? null : value
            }
        }]);
    module.run(['mathFunctionService', (service: $TSFixMe) => { service.registerEvents(); }]);

})(angular.module('topline.services'));